"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugDeviceReadOptions = void 0;
const Endpoints_1 = require("./Endpoints");
class ButtplugDeviceReadOptions {
    constructor(init) {
        this.Endpoint = Endpoints_1.Endpoints.Rx;
        this.Timeout = -1;
        this.ReadLength = -1;
        Object.assign(this, init);
    }
}
exports.ButtplugDeviceReadOptions = ButtplugDeviceReadOptions;
//# sourceMappingURL=ButtplugDeviceReadOptions.js.map